import './site_list.less';

import React from 'react';
import map from 'lodash/map';

import PageThumbnail from 'zoomforth_component_lib/page_thumbnail.jsx';
import PageStatus from 'zoomforth_shared_management/components/page_status.jsx';
import { PlainCheckbox } from 'zoomforth_component_lib/checkbox.jsx';

const SiteListUi = (props) => {
  const {
    sites,
    selected,
    shouldShowCheckbox,
    onToggleSelectSite
  } = props;

  return (
    <div className="sites">
      {map(sites, (site) => {
        return (
          <div onClick={() => onToggleSelectSite(site.id)} key={site.id} className="site">
            {shouldShowCheckbox &&
              <div className="site-selected">
                <PlainCheckbox
                  id={site.id}
                  checked={!!selected[site.id]}
                  onChange={() => onToggleSelectSite(site.id)}
                />
              </div>
            }
            <div className="site-details">
              <div className="site-image">
                <PageThumbnail screenshotUrl={site.screenshot_thumbnail} />
              </div>
              <div className="site-details-content">
                <div className="site-name">
                  <a onClick={(e) => e.stopPropagation()} target="_blank" href={`/site-editor/${site.urlId}`}>{site.name}</a>
                </div>
                <div className="site-uses">Used {site.content_count} times</div>
                <div onClick={(e) => e.stopPropagation()} className="site-status">
                  <PageStatus page={site.model} />
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default SiteListUi;